import { LICENSES_PATH } from 'commons/constants/routes'
import { License } from 'commons/types/DTO/bank/companyDetails/license'
import { TableColumn } from 'ui/components'
import { Link } from 'ui/components/Link'
import { TableActions } from 'ui/components/Table'
import { DotLabelBadge } from 'ui/temp/DotLabelBadge'

import { MappedLicense } from './MappedLicense'

export const columns = (
  onDelete: (item: MappedLicense) => void,
  isAPIConnectionColumnEnabled: boolean,
  navigateToConnections: () => void
) =>
  [
    {
      align: 'left',
      title: 'Name',
      render: ({ id, name }) => (
        <Link to="/licenses/$licenseId" params={{ licenseId: id.toString() }}>
          {name}
        </Link>
      )
    },
    {
      align: 'left',
      title: 'Subtype',
      render: ({ subtype }) => subtype
    },
    {
      align: 'left',
      title: 'Number',
      key: 'number'
    },
    isAPIConnectionColumnEnabled
      ? {
          align: 'left',
          title: 'API Connection',
          render: (item: License) => (
            <>
              {item?.apiConnection && (
                <DotLabelBadge dotActive={item.apiConnection === 'Active'} label={item.apiConnection} />
              )}
            </>
          )
        }
      : null,
    {
      align: 'left',
      title: 'City',
      key: 'city'
    },
    {
      align: 'left',
      title: 'State',
      key: 'state'
    },
    {
      align: 'left',
      title: 'Phone',
      key: 'phone'
    },
    {
      title: 'Actions',
      align: 'left',
      width: '50px',
      render: (item: License) => {
        const items = [
          ...(item?.addConnectionActionEnabled
            ? [
                {
                  type: 'option' as const,
                  title: 'Add API Connection',
                  onClick: () => navigateToConnections()
                }
              ]
            : []),
          {
            type: 'edit' as const,
            url: `${LICENSES_PATH}/${item.id}/edit`
          },
          {
            type: 'delete' as const,
            onClick: () => onDelete(item)
          }
        ]
        return <TableActions items={items} dataQaAttribute={`Licenses-menu-dots-button-${item.id}`} />
      }
    }
  ].filter(Boolean) as TableColumn<License>[]
